import { useAtom } from 'jotai';
import { StudioBaseImageV2 } from '../StudioBaseImage/StudioBaseImage';
import { CommonSectionProps } from '../types';
import * as atoms from './atoms';
import styles from './BuildBundle.module.scss';
import { Step } from './constants';
import { HeaderBaB } from './HeaderBaB';
import { SanityBaBProvider, useBabSanity, useBack, useBundleStore, useHandleSubmit } from './hooks';
import { SecondStep } from './SecondStep';
import { StepSwitcher } from './StepsSwitcher';
import type { SanityProps } from './types';
import TrustpilotWidget from '../TrustpilotWidget';

const BuildBundleV3 = () => {
  const {
    _key: key,
    usedProductsMap,
    header,
    mode = 'section',
    isSecondProductIncluded,
    widget
  } = useBabSanity();

  const { logo, title, subtitle } = header;
  const [img] = useAtom(atoms.imgAtom);
  const [step, setStep] = useAtom(atoms.stepAtom);
  const [secondStepOption] = useAtom(atoms.secondStepOptionAtom);
  const { handleBack } = useBack();
  const { handleSubmit } = useHandleSubmit();

  if (!isSecondProductIncluded) {
    setStep(Step.SECOND_STEP);
  }

  useBundleStore();

  if (!usedProductsMap || !secondStepOption.product || !img) {
    return null;
  }

  const isFirstStep = step === Step.FIRST_STEP;
  const isSecondStep = step === Step.SECOND_STEP;

  return (
    <section className={styles.content} id={key}>
      <StudioBaseImageV2
        image={isFirstStep ? img : secondStepOption.product.imageDesktop}
        className={styles.imageDesktop}
        eagerLoading
      />
      <form onSubmit={handleSubmit} className={styles.productIntro}>
        {widget && (
          <div className={styles.trustpilot}>
            <TrustpilotWidget
              _type="trustpilotWidget"
              _key="tpw"
              templateId={widget?.templateId}
              visibleOnPageLoad={false}
            />
          </div>
        )}
        <HeaderBaB
          mode={mode}
          step={step}
          logo={logo}
          returnBack={handleBack}
          title={title}
          subtitle={subtitle}
          isSecondProductIncluded={isSecondProductIncluded || false}
        />
        {isSecondStep && (
          <StudioBaseImageV2
            className={styles.imageMobile}
            image={secondStepOption.product.imageMobile}
            eagerLoading
          />
        )}
        {isSecondProductIncluded ? <StepSwitcher /> : <SecondStep />}
      </form>
    </section>
  );
};

export const BuildBundleV3Wrapper = (props: SanityProps & CommonSectionProps) => (
  <SanityBaBProvider value={props}>
    <BuildBundleV3 />
  </SanityBaBProvider>
);

export default BuildBundleV3Wrapper;
